<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" :rules="rules" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="客户名称" prop="userId" placeholder="请选择客户名称">
              <el-select v-model="formData.userId" filterable @change="loadOrderList">
                <el-option :label="item.userName" :value="item.userId" v-for="(item, index) of userList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头名称" prop="headerId" placeholder="请选择抬头名称">
              <el-select v-model="formData.headerId" filterable>
                <el-option :label="item.headerName" :value="item.headerId" v-for="(item, index) of headerList"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票金额" prop="invoiceAmount">
              <el-input v-model="formData.invoiceAmount" placeholder="请输入发票金额" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票类型" prop="invoiceType">
              <el-select v-model="formData.invoiceType" filterable>
                <el-option :label="value" :value="key" v-for="([key, value], index) of Array.from(invoiceTypeMap)"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票状态" prop="invoiceStatus">
              <el-select v-model="formData.invoiceStatus">
                <el-option :label="value" :value="key" v-for="([key, value], index) of Array.from(invoiceStatusMap)"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="关联提货订单" prop="objIdList">
              <el-select :disabled="!formData.userId" @change="orderChange" v-model="formData.objIdList" filterable
                multiple>
                <el-option :label="item.label" :value="item.value"
                  v-for="(item, index) of orderList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票备注" prop="invoiceRemark">
              <el-input type="textarea" v-model="formData.invoiceRemark" placeholder="请输入发票备注" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { invoiceType, invoiceStatus, costTypeList } from '@/utils/dict'
import { deepClone } from '@/utils/utils'
export default {
  name: 'InvoiceManageAdd',
  data() {
    return {
      invoiceStatusMap: invoiceStatus,
      userList: [],
      headerList: [],
      orderList: [],
      invoiceTypeMap: invoiceType,
      formData: {
        userId: '', // 关联客户id
        headerId: '', // 抬头ID
        invoiceAmount: '', // 发票金额
        invoiceStatus: '',
        invoiceType: '', // 发票类型1增值税专用发票2普通发票
        fileList: [], // 附件列表
        objIdList: [], // 关联对象id列表
        invoiceRemark: ''
      },
      rules: {
        userId: [{ required: true, message: '请选择客户名称', trigger: ['change', 'blur'] }],
        headerId: [{ required: true, message: '请选择抬头名称', trigger: ['change', 'blur'] }],
        invoiceAmount: [{ required: true, message: '请输入发票金额', trigger: ['change', 'blur'] }],
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: ['change', 'blur'] }],
        objIdList: [{ required: true, message: '请选择', trigger: ['change', 'blur'] }]
      }
    }
  },
  computed: {
    invoiceId() {
      return this.$route.query.invoiceId
    },
    sourceType() {
      return this.$route.query.sourceType || 'TH'
    }
  },
  created() {
    this.loadInvoiceHeaderList()
    this.loadUserList()
    if (this.invoiceId) {
      const map = deepClone(invoiceStatus)
      map.delete('2')
      this.invoiceStatusMap = map
      this.loadDetails()
    }
  },
  methods: {
    orderChange() {
      if (this.sourceType === 'TH') {
        this.formData.invoiceAmount = this.orderList.filter(item => this.formData.objIdList.includes(item.value)).reduce((acc, cur) => parseFloat(acc) + parseFloat(cur.totalAmount), 0)
      } else if (this.sourceType === 'CY') {
        console.log('this.orderList.filter(item => this.formData.objIdList.includes(item.value))', this.orderList.filter(item => this.formData.objIdList.includes(item.value)))
        this.formData.invoiceAmount = this.orderList.filter(item => this.formData.objIdList.includes(item.value)).reduce((acc, cur) => parseFloat(acc) + parseFloat(cur.allPrice), 0)
      }
    },
    loadOrderList(userId) {
      if (this.sourceType === 'TH') {
        this.$axios.get(this.$apis.deliveryOrder.selectYxPickupOrderByPage, {
          pickupStatus: '3',
          page: 1,
          notFp: '1',
          size: 9999,
          userId,
          isPriceOrder: '1' // 云销先提后点的提货单，未点价的订单不能开发票要过滤掉 sourceType=TH
        }).then(res => {
          this.orderList = res.list.map(item => {
            return {
              totalAmount: item.totalAmount,
              label: `${item.pickupNumber} (金额：${item.totalAmount})`,
              value: item.pickupId
            }
          })
        })
      } else if (this.sourceType === 'CY') {
        this.$axios.get(this.$apis.oilTankCost.selectYgCostByPage, {
          userId,
          notFp: '1'
        }).then(res => {
          this.orderList = res.list.map(item => {
            return {
              allPrice: item.allPrice,
              label: `${costTypeList.get(item.costType)} (单价：${item.unitPrice})(数量：${item.ygNumber})`,
              value: item.id
            }
          })
        })
      }
    },
    loadInvoiceHeaderList() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceHeaderByPage, this.searchForm).then(res => {
        this.headerList = res.list
      })
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3',
        page: 1,
        size: 999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadDetails() {
      this.$axios.get(this.$apis.lyInvoice.selectLyInvoiceByInvoiceId, {
        params: { invoiceId: this.invoiceId }
      }).then(res => {
        // res.objIdList = res.objList.map(item => item.pickupId)
        this.loadOrderList(res.userId)
        this.formData = res
        console.log('res', res)
      })
    },
    submit() {
      this.$refs.formData.validate().then(() => {
        let url = this.$apis.lyInvoice[`insert${this.sourceType}Invoice`]
        if (this.invoiceId) {
          url = this.$apis.lyInvoice.updateLyInvoice
        }
        this.$axios.post(url, this.formData).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
